import { Menu } from '@mui/material';
import React from 'react';

interface IAddTaskMenuProps {
	addButtonRef: HTMLDivElement | undefined;
	isOpen: boolean;
	onClick: () => void;
	children: JSX.Element | JSX.Element[];
}

const AddTaskMenu = ({
	addButtonRef,
	isOpen,
	onClick,
	children
}: IAddTaskMenuProps) => (
	<Menu
		data-testid="add-task-menu"
		open={isOpen}
		hideBackdrop
		onClick={onClick}
		anchorEl={addButtonRef}
		anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
		aria-labelledby="flow-add-task-button"
		sx={{ marginLeft: 2 }}
	>
		{children}
	</Menu>
);

AddTaskMenu.defaultProps = {};

export default AddTaskMenu;
